var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"container d-flex"},[_c('cost-basic-code-combo-box',{ref:'costBasicCodeComboBox',on:{"change:costBasicCode":_vm.changeCostBasicCode}}),_c('cost-dvsn-code-combo-box',{ref:'costDvsnCodeComboBox'}),_c('cost-info-btn-new',{ref:'costInfoBtnNew',on:{"save":_vm.onSave}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }